import Table from '../../../table/Table'
import TableRow from '../../../table/TableRow'
import _ from 'underscore'
import $ from "jquery"

function TabularDataTable() {}

TabularDataTable.prototype = _.create(Table.prototype);

TabularDataTable.prototype.init = function( tHeadEl, changesCallback, validateCallback )
{
    Table.call( this, tHeadEl );

    this._validateCallback = validateCallback;
    this._validationDetected = function ()
    {
        if( this._validateCallback )
            this._validateCallback();
    };

    this._changesCallback = changesCallback;
    this._changesDetected = function ()
    {
        if( this._changesCallback )
            this._changesCallback();
    };

    return this;
};

TabularDataTable.prototype.addRow = function( row )
{
    Table.prototype.addRow.call( this, row );
    row.validate();
};

TabularDataTable.prototype.updateRow = function(rowIndex, row) {
    Table.prototype.replaceRowAndUpdateDOM.call( this, rowIndex, row );
    row.validate();
}

// abstract
TabularDataTable.prototype.createEmptyRow = function()
{
    return new TableRow();
};


TabularDataTable.prototype.addEmptyRow = function(  )
{
    var row = this.createEmptyRow();
    Table.prototype.addRow.call( this, row );
    row.buildDOM( this.getTBody() );
    row.writeCellsContent();
    row.getRowEl().className = this.getRowElClasses( row.getRowIdx() ).join(" ");
    this.updateTableClasses();
};


TabularDataTable.prototype.buildDOM = function( containerEl )
{
    Table.prototype.buildDOM.call(this, containerEl);
    this.updateTableClasses();
};

TabularDataTable.prototype.getBaseTableClasses = function()
{
    return ["tabularDataTable"];
};

TabularDataTable.prototype.updateTableClasses = function()
{
    var classes = this.getBaseTableClasses();
    if( this.rows.length == 0 )
        classes.push("noRows");
    this.tableEl.className = classes.join(" ");
};


TabularDataTable.prototype.updateUI = function()
{
    this.updateTableClasses();
    for( var i = 0; i < this.rows.length; i++ )
        this.rows[i].updateUI();
};

TabularDataTable.prototype.validate = function()
{
    var valid = true;
    for( var i = 0; i < this.rows.length; i++ )
    {
        var row = this.rows[i];
        var rowValid = row.isMarkedToRemove() || row.validate();
        valid = valid && rowValid;
    }
    return valid;
};

TabularDataTable.prototype.doToggleRemove = function( rowIdx )
{
    var row = this.getRow( rowIdx );
    if( row.isMarkedToRemove() )
    {
        row.unMarkToRemove();
    }
    else if( row.canBeDeletedPermanently() )
    {
        this.removeRow( rowIdx );
        this.updateTableClasses();
        this.onRowAmountChange();
    }
    else
    {
        row.markToRemove();
    }
};

TabularDataTable.prototype.toggleRemove = function( rowIdx )
{
    this.doToggleRemove( rowIdx );
    this._validationDetected();
    this._changesDetected();
};

TabularDataTable.prototype.hasErrors = function()
{
    for( var i = 0; i < this.rows.length; i++ )
        if( this.rows[i].hasErrors() )
            return true;
    return false;
};

TabularDataTable.prototype.disableTextSelection = function()
{
    // do not disable selection;
};

TabularDataTable.prototype.onRowAmountChange = function() {
    $(this).trigger("rowAmountChanged");
}

export default TabularDataTable



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/TabularDataTable.js